import { registerSW } from "virtual:pwa-register";

/**
 * Lo que hace la app al arrancar, antes de pintar nada (src/main.tsx).
 *
 * 1. Identidad fresca: Atomic guarda el usuario actual (nombre, administrador) en
 *    localStorage y no lo vuelve a leer hasta cerrar sesión. Se borra al arrancar para que
 *    un cambio de nombre o de permisos se vea con solo recargar (petición de Robert,
 *    01/10/2026). Cuesta una consulta por carga.
 * 2. Versión nueva sin intervención: la app instalable (PWA) guarda una copia para
 *    funcionar sin red. Al publicar, el service worker nuevo se activa solo y la página se
 *    recarga una vez con la versión nueva (registerType "autoUpdate" en vite.config.ts).
 *    Se comprueba al abrir la app y cada vez que vuelve a primer plano (móvil), no a
 *    intervalos: así nunca se recarga mientras alguien está escribiendo.
 * 3. Vuelta de un correo de acceso que llega a la app en vez de a auth-callback.html
 *    (#access_token=… o #error=…, por ejemplo con una copia antigua de la app que servía la
 *    app para //auth-callback.html): se manda a auth-callback.html con lo mismo, que sabe
 *    qué hacer (09/10/2026).
 */
const CLAVE_USUARIO_ACTUAL = "RaStore.auth.current_sale";

/** false si la página se va a otra dirección (punto 3): entonces no se pinta la app. */
export const arrancar = (): boolean => {
  if (
    /^#(access_token|error|error_code)=/.test(window.location.hash) &&
    window.location.pathname !== "/auth-callback.html"
  ) {
    window.location.replace(`/auth-callback.html${window.location.hash}`);
    return false;
  }
  try {
    window.localStorage.removeItem(CLAVE_USUARIO_ACTUAL);
  } catch {
    // sin localStorage (modo privado estricto): Atomic ya lee el usuario sin caché
  }

  if (!("serviceWorker" in navigator)) return true;
  registerSW({
    immediate: true,
    onRegisteredSW(_url, registro) {
      if (!registro) return;
      document.addEventListener("visibilitychange", () => {
        if (document.visibilityState === "visible") {
          registro.update().catch(() => {
            // sin red: se comprobará la próxima vez
          });
        }
      });
    },
  });
  return true;
};
